module.exports = __webpack_public_path__ + "static/media/24.35064a6c.mp3";